import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from "@angular/core";
import { ProductCategory, ProductShape, productShapes } from "../../../core/e-commerce/_models/product";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar } from "@angular/material";
import { AuthNoticeService } from "../../../core/auth";
import { ProductsService } from "../../../core/e-commerce/_services/products.service";
import { NgxDropzoneChangeEvent, NgxDropzoneComponent } from "ngx-dropzone";
import { OrderEvent, OrderEventsService } from "../../../core/e-commerce";
import { DialogSearchUserComponent } from "../dialog-search-user/dialog-search-user.component";
import { HttpClient } from "@angular/common/http";
import { MatOptionSelectionChange } from "@angular/material/core";
import { map, startWith } from "rxjs/operators";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { statusMap } from "../../../core/e-commerce/_models/order-event";
import { ConfirmComponent } from "../confirm/confirm.component";
import { ConstantsUtils } from "../../../core/utils/constants-utils";
import { environment } from "../../../../environments/environment";

@Component({
  selector: "kt-dialog-product",
  templateUrl: "./dialog-order.component.html",
  styleUrls: ["./dialog-order.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogOrderComponent implements OnInit {
  isUserAssign: boolean = false;
  detailForm: FormGroup;
  trackingForm: FormGroup;
  error: boolean = false;
  categories: ProductCategory[];
  shapes: ProductShape[] = productShapes;
  principalImage: File[] = [];
  principalImagePath: string;
  @ViewChild("dropzone") dropzone: NgxDropzoneComponent;
  origins = [
    // {
    // 	name: 'Revendedora',
    // 	value: 'Reseller',
    // },
    {
      name: "Administrativo",
      value: "Administrative"
    }
    // {
    // 	name: 'Automático',
    // 	value: 'Automatic',
    // }
  ];
  status = ConstantsUtils.orderEventStatus;
  private statusMap = statusMap;
  public types: any;
  public results: any;
  public orders: any;
  orderExists = true;
  productsList = [];
  productsCtrl = new FormControl();
  filteredProducts: any;
  fotografia: any;
  inputCantidad = new FormControl({ value: 1, disabled: true });
  selectedProduct: any;
  isLoadingResults = false;
  currentCampaignData: false;
  campaignInitialized: boolean;
  productsCurrentOrder = [];
  dataSource = new MatTableDataSource();
  dataSourceTrackings = new MatTableDataSource();
  displayedColumns: string[] = [
    "codigo",
    // 'fotografia',
    "nombre",
    // 'precioFolleto',
    // 'precioPagar',
    // 'ganancia',
    // 'total',
    "price",
    "actions"
  ];
  displayedColumnsTracking: string[] = ["timestamp", "orderEventStatus", "applicationUserName", "descriptionStatus"];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  private orderAmount: any;
  private estimatedProfit: any;
  private orderAmountByPrice: any;
  private foulDays: number;
  private foulHours: number;
  private foulMins: number;
  private replaceProductTypeId = 8;
  private wrongProductTypeId = 4;
  private campaignProductTypeId = 5;
  isReplacement = true;
  productsListReplacement = [];
  productsCtrlReplacement = new FormControl();
  filteredProductsReplacement: any;
  inputCantidadReplacement = new FormControl({ value: 1, disabled: true });
  selectedProductReplacement: any;
  productsReplacement = [];
  dataSourceReplacement = new MatTableDataSource();
  isResolved: boolean;
  productsListCampaign = [];
  productsCtrlCampaign = new FormControl();
  filteredProductsCampaign: any;
  inputCantidadCampaign = new FormControl({ value: 1, disabled: true });
  selectedProductCampaign: any;
  productsCampaign = [];
  dataSourceCampaign = new MatTableDataSource();
  private selectedOrder: any;
  isReturnCampaign: boolean;

  constructor(
    private _snackBar: MatSnackBar,
    private http: HttpClient,
    private dialog: MatDialog,
    private orderEventsService: OrderEventsService,
    private cdr: ChangeDetectorRef,
    public dialogRef: MatDialogRef<DialogOrderComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: DialogData,
    private fb: FormBuilder,
    private authNoticeService: AuthNoticeService,
    private productsService: ProductsService
  ) {}

  ngOnInit() {
    this.authNoticeService.setNotice(null);
    this.loadCategories();
    this.loadResults();
    this.loadTypes();
    this.initForms();
    this.initOrderTable();
    if (this.data.orderEventData) {
      if (this.data.orderEventData.orderEventTypeId === this.replaceProductTypeId) {
        this.isReplacement = true;
      }
      if (this.data.orderEventData.orderEventTypeId === this.campaignProductTypeId) {
        this.isReturnCampaign = true;
      }
      this.isUserAssign = true;
      // this.orders = this.getOrders();
      this.getProducts(this.data.orderEventData.orderId);
      this.productsCurrentOrder = this.data.orderEventData.orderEventItems.map(function (orderEventItem) {
        return {
          orderItemId: orderEventItem.id,
          quantityToReturn: orderEventItem.quantity,
          productCode: orderEventItem.code,
          productName: orderEventItem.name,
          price: orderEventItem.price
        };
      });
      this.productsReplacement = this.data.orderEventData.replacementItems.map(function (orderEventItem) {
        return {
          orderItemId: orderEventItem.campaignProductReplacementId,
          quantityToReturn: orderEventItem.quantity,
          productCode: orderEventItem.code,
          productName: orderEventItem.name,
          price: orderEventItem.price
        };
      });
      this.productsCampaign = this.data.orderEventData.orderEventProducts.map(function (orderEventItem) {
        return {
          orderItemId: orderEventItem.campaignProductReturnId,
          quantityToReturn: orderEventItem.quantity,
          productCode: orderEventItem.code,
          productName: orderEventItem.name,
          price: orderEventItem.price
        };
      });
      if (this.productsCurrentOrder.length > 0) {
        this.dataSource = new MatTableDataSource(this.productsCurrentOrder);
      }
      if (this.productsReplacement.length > 0) {
        this.dataSourceReplacement = new MatTableDataSource(this.productsReplacement);
      }
      if (this.productsCampaign.length > 0) {
        this.dataSourceCampaign = new MatTableDataSource(this.productsCampaign);
      }
      if (this.data.orderEventData.orderEventTrackings.length > 0) {
        this.dataSourceTrackings = new MatTableDataSource(this.data.orderEventData.orderEventTrackings);
      }
    }
    this.limitStatus();
  }

  private limitStatus() {
    if (this.data.orderEventData) {
      let event = this.data.orderEventData;
      let status = ConstantsUtils.orderEventStatus;
      for (let i = 0; i < status.length; i++) {
        if (status[i].value === event.orderEventStatus) {
          this.status = status.slice(i + 1, status.length);
          return;
        }
      }
    }
  }

  private loadTypes() {
    this.orderEventsService.getOrderEventTypes().subscribe(
      (resp) => {
        this.types = resp;
        this.cdr.detectChanges();
      },
      (error) => {
        console.log(error);
      }
    );
  }

  private loadResults() {
    this.orderEventsService.getOrderEventResults().subscribe(
      (resp) => {
        this.results = resp;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  initForms() {
    this.detailForm = this.fb.group({
      orderEventOriginType: [
        {
          value: this.data.orderEventData ? this.data.orderEventData.orderEventOriginType : this.origins[0].value,
          disabled: this.data.orderEventData
        },
        Validators.required
      ],
      orderEventTypeId: [
        {
          value: this.data.orderEventData ? this.data.orderEventData.orderEventTypeId : "",
          disabled: this.data.orderEventData
        },
        Validators.required
      ],
      user: [
        {
          value: this.data.cachedOrderEventData
            ? this.data.cachedOrderEventData.userName +
              " - " +
              this.data.cachedOrderEventData.firstName +
              " " +
              this.data.cachedOrderEventData.lastName
            : "",
          disabled: this.data.orderEventData
        },
        Validators.required
      ],
      applicationUserId: [
        this.data.orderEventData ? this.data.orderEventData.applicationUserId : "",
        Validators.required
      ],
      descriptionEvent: [null, Validators.required],
      orderId: [
        {
          value: this.data.orderEventData ? this.data.orderEventData.orderId : "",
          disabled: this.data.orderEventData
        },
        Validators.required
      ]
    });

    this.trackingForm = this.fb.group({
      orderEventStatus: [null, Validators.required],
      description: [null, Validators.required],
      orderEventResult: [null]
    });
  }

  saveOrderEvent(confirm = false) {
    const controls = this.detailForm.controls;
    if (this.detailForm.invalid) {
      Object.keys(controls).forEach((controlName) => {
        controls[controlName].markAsTouched();
      });
      return;
    }

    if (
      this.productsTotalPrice(this.productsReplacement) >
      1.1 * (this.productsTotalPrice(this.productsCurrentOrder) + this.productsTotalPrice(this.productsCampaign))
    ) {
      this._snackBar.open(
        "Los productos de reemplazo no pueden superar el 110% del precio de los productos a cambiar.",
        "OK",
        { duration: 3000 }
      );
      return;
    } else {
      if (
        this.isReplacement &&
        !confirm &&
        this.productsTotalPrice(this.productsReplacement) <
          this.productsTotalPrice(this.productsCurrentOrder) + this.productsTotalPrice(this.productsCampaign)
      ) {
        const dialogRef = this.dialog.open(ConfirmComponent, {
          width: "400px",
          data: {
            mensaje:
              "Está haciendo un cambio por un monto menor al de los productos a cambiar. No se le devolverá la diferencia.",
            title: "Atención"
          }
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result === "ok") {
            this.saveOrderEvent(true);
          }
        });
        return;
      }
    }

    let data = this.detailForm.value;
    // data.orderEventTrackings = [
    // 	{
    // 		'descriptionStatus': data.description,
    // 		'orderEventStatus': 'New',
    // 		'orderEventResultId': 1,
    // 	}
    // ];
    data.billNumber = 0; // todo: is 0 until module developed
    delete data.user;
    data.orderEventItems = this.productsCurrentOrder.map(function (orderEventItem) {
      return {
        orderItemId: orderEventItem.id,
        quantity: orderEventItem.quantityToReturn
      };
    });
    data.replacementItems = this.productsReplacement.map(function (orderEventItem) {
      return {
        campaignProductReplacementId: orderEventItem.orderItemId,
        quantity: orderEventItem.quantityToReturn
      };
    });
    data.orderEventProducts = this.productsCampaign.map(function (orderEventItem) {
      return {
        campaignProductReturnId: orderEventItem.orderItemId,
        quantity: orderEventItem.quantityToReturn
      };
    });
    if (this.data.orderEventData == null) {
      this.orderEventsService.createOrderEvent(this.detailForm.value).subscribe(
        (resp) => {
          this.dialogRef.close(true);
          this.cdr.detectChanges();
        },
        (error) => {
          this._snackBar.open(error.error, "OK", { duration: 3000 });
        }
      );
    } else {
      // this.orderEventsService.updateOrderEvent(this.detailForm.value, this.data.orderEventData.id).subscribe(resp => {
      // 		this.dialogRef.close(true);
      // 	},
      // 	error => {
      // 	});
    }
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.detailForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  private loadCategories() {
    this.productsService.getProductCategories().subscribe(
      (resp) => {
        this.categories = resp;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  principalImageChanged($event: NgxDropzoneChangeEvent) {
    this.principalImage.splice(0, 1);
    this.principalImage.push(...$event.addedFiles);
    if (this.data.orderEventData) {
      this.productsService.uploadImage(this.data.orderEventData.id, $event.addedFiles[0], "Principal").subscribe(
        (response) => {
          this.principalImageRemoved();
          this.cdr.detectChanges();
        },
        (error) => {
          this.cdr.detectChanges();
        }
      );
    }
  }

  principalImageRemoved() {
    // this.principalImage = [];
    this.principalImagePath = null;
  }

  openDialogSearchUser() {
    const dialogRef = this.dialog.open(DialogSearchUserComponent, {
      width: "60%",
      data: { userName: null }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.detailForm.patchValue({ user: result.userName + " - " + result.firstName + " " + result.lastName });
        this.detailForm.patchValue({ applicationUserId: result.id });
        this.isUserAssign = true;
        this.orders = this.getOrders();
      }
    });
  }

  quitUser() {
    this.detailForm.controls["user"].setValue(null);
    this.detailForm.controls["applicationUserId"].setValue(null);
    this.isUserAssign = false;
    this.orders = null;
  }

  getOrders() {
    this.http
      .get(environment.API_URL + "api/Orders/fororderevent/" + this.detailForm.value.applicationUserId)
      .subscribe((value) => {
        this.orders = value;
        this.cdr.detectChanges();
        if (this.data.orderEventData) {
          this.getProducts(this.data.orderEventData.orderId);
          this.getProductsReplacement(this.data.orderEventData.orderId);
          this.getProductsCampaign(this.data.orderEventData.orderId);
        }
      });
  }

  getProducts(value) {
    this.http.get(environment.API_URL + "api/Orders/" + value).subscribe((order) => {
      this.productsList = order["orderItems"];
      this.filteredProducts = this.productsCtrl.valueChanges.pipe(
        startWith(""),
        map((products) => (products ? this._filterProducts(products, this.productsList) : this.productsList.slice()))
      );
    });
  }

  private _filterProducts(value: string, list) {
    const filterValue = value.toLowerCase();
    return list.filter(
      (product) =>
        product.productName.toLowerCase().indexOf(filterValue) === 0 ||
        product.productCode.toString().indexOf(filterValue) === 0
    );
  }

  inputChange($event: KeyboardEvent) {
    if ($event.keyCode === 8) {
      this.selectedProduct = null;
      this.inputCantidad.setValue(1);
    }
  }

  onSelectionChanged($event: MatOptionSelectionChange, product: any) {
    this.selectedProduct = product;
  }

  removeNewProduct() {
    let cant = Number(this.inputCantidad.value);
    if (cant > 1) {
      cant--;
      this.inputCantidad.setValue(cant);
    }
  }

  validationInput($event: KeyboardEvent) {}

  addNewProduct() {
    if (this.selectedProduct) {
      let cant = Number(this.inputCantidad.value);
      if (cant < this.selectedProduct.quantity) {
        cant++;
        this.inputCantidad.setValue(cant);
      }
    }
  }

  agregarProducto() {
    if (this.selectedProduct != null) {
      let cant = Number(this.inputCantidad.value);
      let element = this.productsCurrentOrder.find((p) => p.productCode === this.selectedProduct.productCode);
      if (!element) {
        this.selectedProduct.paymentCycle = 1;
        this.selectedProduct.quantityToReturn = cant;
        this.productsCurrentOrder.push(this.selectedProduct);
        this.dataSource = new MatTableDataSource(this.productsCurrentOrder);
      }
    }
  }

  search(value: any) {}

  removeProduct(product: any) {
    if (product.quantityToReturn > 1) {
      let index = this.productsCurrentOrder.indexOf(product);
      product.quantityToReturn--;
      this.productsCurrentOrder[index] = product;
      this.dataSource = new MatTableDataSource(this.productsCurrentOrder);
    }
  }

  addProduct(product: any) {
    if (product.quantityToReturn < product.quantity) {
      let index = this.productsCurrentOrder.indexOf(product);
      product.quantityToReturn++;
      this.productsCurrentOrder[index] = product;
      this.dataSource = new MatTableDataSource(this.productsCurrentOrder);
    }
  }

  deleteProduct(product: any) {
    this.productsCurrentOrder = this.productsCurrentOrder.filter((orderProduct) => orderProduct.id !== product.id);
    this.dataSource = new MatTableDataSource(this.productsCurrentOrder);
  }

  orderSelected(event: any = null) {
    this.productsCtrl = new FormControl();
    this.productsCtrlReplacement = new FormControl();
    this.productsCtrlCampaign = new FormControl();
    this.productsCurrentOrder = [];
    this.productsReplacement = [];
    this.productsCampaign = [];
    this.dataSource = new MatTableDataSource(this.productsCurrentOrder);
    this.dataSourceReplacement = new MatTableDataSource(this.productsReplacement);
    this.dataSourceCampaign = new MatTableDataSource(this.productsReplacement);
    if (event) {
      this.selectedOrder = event.value;
    }
    this.getProducts(this.selectedOrder);
    this.getProductsReplacement(this.selectedOrder);
    this.getProductsCampaign(this.selectedOrder);
  }

  initOrderTable() {
    this.inputCantidad.setValue(1);
    this.inputCantidadReplacement.setValue(1);
    this.productsCurrentOrder.sort(function (a, b) {
      return a.productCode - b.productCode;
    });
    this.dataSource = new MatTableDataSource(this.productsCurrentOrder);
    this.setDataOrder();
    this.isLoadingResults = false;
    setTimeout(() => {
      this.dataSource.paginator = this.paginator;
      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }
    });
    this.cdr.detectChanges();
  }

  setDataOrder() {
    if (this.productsCurrentOrder.length > 0) {
      this.productsCurrentOrder.forEach((x) => {
        if (x.paymentCycle === 1) {
          this.orderAmount = this.orderAmount + x.finalPrice * x.quantity;
          this.estimatedProfit = this.estimatedProfit + (x.price - x.finalPrice) * x.quantity;
          this.orderAmountByPrice = this.orderAmountByPrice + x.price * x.quantity;
        }
      });
    }

    /*
		if (this.currentCampaignData) {
			let currentDate = moment();
			let startDate = moment(this.currentCampaignData.startDateZona).startOf('day');
			let endDate = moment(this.currentCampaignData.endDateZona).endOf('day');
			if (currentDate.isBefore(startDate)) {
				this.campaignInitialized = false;
				let durationToStart = moment.duration(startDate.diff(currentDate), 'milliseconds');
				this.foulDays = durationToStart.days();
				this.foulHours = durationToStart.hours();
				this.foulMins = durationToStart.minutes();
			} else {
				this.campaignInitialized = true;
				let durationToEnd = moment.duration(endDate.diff(currentDate), 'milliseconds');
				this.foulDays = durationToEnd.days();
				this.foulHours = durationToEnd.hours();
				this.foulMins = durationToEnd.minutes();
			}
		}
		 */
  }

  saveOrderEventTracking() {
    const controls = this.trackingForm.controls;
    if (this.trackingForm.invalid) {
      Object.keys(controls).forEach((controlName) => {
        controls[controlName].markAsTouched();
      });
      return;
    }

    let data = {
      descriptionStatus: this.trackingForm.value.description,
      orderEventStatus: this.trackingForm.value.orderEventStatus,
      orderEventResultId:
        this.trackingForm.value.orderEventStatus === "Resolved" ? this.trackingForm.value.orderEventResult : 1
    };
    this.orderEventsService.createOrderEventTracking(data, this.data.orderEventData.id).subscribe(
      (resp) => {
        this.dialogRef.close(true);
        this.cdr.detectChanges();
      },
      (error) => {}
    );
  }

  getProductsReplacement(value) {
    let order = this.orders.find((item) => item.id === value);
    if (!order) {
      return;
    }

    let request;
    if (this.detailForm.value.orderEventTypeId === this.wrongProductTypeId) {
      request = this.orderEventsService.getProductsCampaignComputable(order.campaignId);
    } else {
      request = this.orderEventsService.getProductsCampaignCurrentComputable(this.detailForm.value.applicationUserId);
    }

    request.subscribe((result) => {
      this.productsListReplacement = result.map(function (item) {
        return {
          orderItemId: item.id,
          quantityToReturn: 0,
          productCode: item.product.code,
          productName: item.product.name,
          price: item.price
        };
      });
      this.filteredProductsReplacement = this.productsCtrlReplacement.valueChanges.pipe(
        startWith(""),
        map((products) =>
          products ? this._filterProducts(products, this.productsListReplacement) : this.productsListReplacement.slice()
        )
      );
    });
  }

  onSelectionChangedReplacement($event: MatOptionSelectionChange, product: any) {
    this.selectedProductReplacement = product;
  }

  checkType(value) {
    if (value === this.campaignProductTypeId) {
      this.isReturnCampaign = true;
    } else {
      this.isReturnCampaign = false;
    }
    this.orderSelected();
  }

  removeNewProductReplacement() {
    let cant = Number(this.inputCantidadReplacement.value);
    if (cant > 1) {
      cant--;
      this.inputCantidadReplacement.setValue(cant);
    }
  }

  addNewProductReplacement() {
    let cant = Number(this.inputCantidadReplacement.value);
    cant++;
    this.inputCantidadReplacement.setValue(cant);
  }

  agregarProductoReplacement() {
    if (this.selectedProductReplacement != null) {
      let cant = Number(this.inputCantidadReplacement.value);
      let element = this.productsReplacement.find((p) => p.productCode === this.selectedProductReplacement.productCode);
      if (!element) {
        this.selectedProductReplacement.paymentCycle = 1;
        this.selectedProductReplacement.quantityToReturn = cant;
        this.productsReplacement.push(this.selectedProductReplacement);
        this.dataSourceReplacement = new MatTableDataSource(this.productsReplacement);
      }
    }
  }

  removeProductReplacement(product: any) {
    if (product.quantityToReturn > 1) {
      let index = this.productsReplacement.indexOf(product);
      product.quantityToReturn--;
      this.productsReplacement[index] = product;
      this.dataSourceReplacement = new MatTableDataSource(this.productsReplacement);
    }
  }

  addProductReplacement(product: any) {
    let index = this.productsReplacement.indexOf(product);
    product.quantityToReturn++;
    this.productsReplacement[index] = product;
    this.dataSourceReplacement = new MatTableDataSource(this.productsReplacement);
  }

  deleteProductReplacement(product: any) {
    this.productsReplacement = this.productsReplacement.filter((orderProduct) => orderProduct.id !== product.id);
    this.dataSourceReplacement = new MatTableDataSource(this.productsReplacement);
  }

  statusSelectionChange(value) {
    this.isResolved = value === "Resolved";
  }

  productsTotalPrice(array) {
    let total = 0;
    for (let i = 0; i < array.length; i++) {
      total = total + array[i].price * array[i].quantityToReturn;
    }
    return total;
  }

  getProductsCampaign(value) {
    let order = this.orders.find((item) => item.id === value);
    if (!order) {
      return;
    }
    this.orderEventsService.getProductsCampaignComputable(order.campaignId).subscribe((result) => {
      this.productsListCampaign = result.map(function (item) {
        return {
          orderItemId: item.id,
          quantityToReturn: 0,
          productCode: item.product.code,
          productName: item.product.name,
          price: item.price
        };
      });
      this.filteredProductsCampaign = this.productsCtrlCampaign.valueChanges.pipe(
        startWith(""),
        map((products) =>
          products ? this._filterProducts(products, this.productsListCampaign) : this.productsListCampaign.slice()
        )
      );
    });
  }

  onSelectionChangedCampaign($event: MatOptionSelectionChange, product: any) {
    this.selectedProductCampaign = product;
  }

  removeNewProductCampaign() {
    let cant = Number(this.inputCantidadCampaign.value);
    if (cant > 1) {
      cant--;
      this.inputCantidadCampaign.setValue(cant);
    }
  }

  addNewProductCampaign() {
    let cant = Number(this.inputCantidadCampaign.value);
    cant++;
    this.inputCantidadCampaign.setValue(cant);
  }

  agregarProductoCampaign() {
    if (this.selectedProductCampaign != null) {
      let cant = Number(this.inputCantidadCampaign.value);
      let element = this.productsCampaign.find((p) => p.productCode === this.selectedProductCampaign.productCode);
      if (!element) {
        this.selectedProductCampaign.paymentCycle = 1;
        this.selectedProductCampaign.quantityToReturn = cant;
        this.productsCampaign.push(this.selectedProductCampaign);
        this.dataSourceCampaign = new MatTableDataSource(this.productsCampaign);
      }
    }
  }

  removeProductCampaign(product: any) {
    if (product.quantityToReturn > 1) {
      let index = this.productsCampaign.indexOf(product);
      product.quantityToReturn--;
      this.productsCampaign[index] = product;
      this.dataSourceCampaign = new MatTableDataSource(this.productsCampaign);
    }
  }

  addProductCampaign(product: any) {
    let index = this.productsCampaign.indexOf(product);
    product.quantityToReturn++;
    this.productsCampaign[index] = product;
    this.dataSourceCampaign = new MatTableDataSource(this.productsCampaign);
  }

  deleteProductCampaign(product: any) {
    this.productsCampaign = this.productsCampaign.filter((orderProduct) => orderProduct.id !== product.id);
    this.dataSourceCampaign = new MatTableDataSource(this.productsCampaign);
  }
}

export interface DialogData {
  cachedOrderEventData: any;
  orderEventData: OrderEvent;
}
